import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { WISHLIST_ENTRY_LIST } from '../wishlist-state';

export const LOAD_WISHLIST_ENTRY_LIST = '[Wishlist] Load Wishlist Entry List';
export const LOAD_WISHLIST_ENTRY_LIST_SUCCESS = '[Wishlist] Load Wishlist Entry List Success';
export const LOAD_WISHLIST_ENTRY_LIST_FAIL = '[Wishlist] Load Wishlist Entry List Fail';
export const RESET_WISHLIST_ENTRY_LIST = '[Wishlist] Reset Wishlist Entry List';

export class LoadWishlistEntryList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_WISHLIST_ENTRY_LIST;

  constructor() {
    super(WISHLIST_ENTRY_LIST);
  }
}

export class LoadWishlistEntryListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_WISHLIST_ENTRY_LIST_SUCCESS;

  constructor(public payload: WishlistEntry[]) {
    super(WISHLIST_ENTRY_LIST);
  }
}

export class LoadWishlistEntryListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_WISHLIST_ENTRY_LIST_FAIL;

  constructor(public payload: unknown) {
    super(WISHLIST_ENTRY_LIST);
  }
}

export class ResetWishlistEntryList extends StateUtils.LoaderResetAction {
  readonly type = RESET_WISHLIST_ENTRY_LIST;

  constructor() {
    super(WISHLIST_ENTRY_LIST);
  }
}

export type WishlistEntryListActions =
  | LoadWishlistEntryList
  | LoadWishlistEntryListSuccess
  | LoadWishlistEntryListFail
  | ResetWishlistEntryList;
